import {
  ReadCustomFormFieldsJsonRequest,
  UpsertCustomFormField,
  UpsertCustomFormFieldsRequest,
  MembershipTypeRecordStatus,
} from '@/apiClient';
import { Dispatch, SetStateAction } from 'react';

export type TMembershipContext = {
  membershipTypes: TMembershipType[];
  setMembershipType: Dispatch<SetStateAction<TMembershipType[]>>;
  billing: TBillingConfig;
  setBilling: Dispatch<SetStateAction<TBillingConfig>>;
  isDirty: boolean;
  setDirty: Dispatch<SetStateAction<boolean>>;
};

export enum EMemberConfigurationTabs {
  ADDITIONAL_INFO = 'additional-information',
  COMPARISON_TABLE = 'comparison-table',
  MEMBERSHIP_SETTINGS = 'membership-settings',
}

// AdditionalInfo
export type TReadCustomFormPayload = ReadCustomFormFieldsJsonRequest;

export type TCustomFormFieldPayload = UpsertCustomFormFieldsRequest;

export type TFieldConfigs = UpsertCustomFormField;

export enum ERecordStatus {
  ACTVE = 1,
  INACTIVE = 2,
}

export enum EMemberIdentFlag {
  MANUAL_ASSIGN = 0,
  AUTO_ASSIGN = 1,
  USED_STUD_LETTERS = 2,
}

// Membership Settings
export type TMembershipType = {
  id: string;
  order: number;
  name: string;
  annualPrice: number;
  recordStatus: MembershipTypeRecordStatus;
  membershipTypeId?: number;
};

export type TBillingConfig = {
  startDate: Date;
  renewalPeriod: number;
  gracePeriod: number;
};

export type TMemberIdent = {
  memberIdent: EMemberIdentFlag;
  seed: number;
  identLabel?: string;
};
